import AboutData from './AboutData';
import ProductSpecificationsData from './KeyFeaturesData';
import HowDoesitWork from './HowDoesitWork';
import HowIsItUsed from './HowIsItUsed';
import ProductFor from './ProductFor';
import HowToPurchaseData from './HowToPurchaseData';

export default function PemrData(productname) {
  const minAge = 0;
  const maxAge = 85;
  const minCoverageAmount = 50000;
  const maxCoverageAmount = 10000000;
  const paymenttypes='Very customizable'
 return {
  name: 'Permanent Life Insurance',
   specs: {
      age: { min: minAge, max: maxAge },
      coverageAmount: { min: minCoverageAmount, max: maxCoverageAmount },
      paymenttypes:{types:paymenttypes}
    },
    about: AboutData(productname),
    productSpecifications: ProductSpecificationsData(minAge, maxAge, minCoverageAmount, maxCoverageAmount, paymenttypes,productname),
    work:HowDoesitWork(productname),
    productuse: HowIsItUsed(productname),
    productfor: ProductFor(productname),
    howtopurchase:HowToPurchaseData(productname)
  }
}



// WEBPACK FOOTER //
// ./src/components/Common/data/products/perm/PermData.js